// extracted by mini-css-extract-plugin
export default {"content":"d9j5pY_AtB37FDuY8vRU","contentRow":"mt4SEvMf5xiZKK5oIoFo","labelItem":"hvrE948DiIWpuisT6S5o","label":"Mb1M6DNIiJ7N5x1VIBWL","footer":"M9wuGp5ppAi_sUxkc98g"};